<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Seguros y Extras
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div
            v-if="transportMode === transportModeTypeEnum.maritime"
            class="items"
            @mouseover="setMessageInformation('Seleccione esta elemento para asegurar la carga')"
            @mouseleave="setMessageInformation()"
          >
            <label style="cursor: pointer">
              <input
                v-model="insuranceAndExtras.seaFreightImportInsurance"
                class="uk-checkbox"
                type="checkbox"
              > Seguros al transporte marítimo en importacion
            </label>
          </div>

          <div
            v-if="insuranceAndExtras.seaFreightImportInsurance && transportMode === transportModeTypeEnum.maritime"
            class="uk-margin-right"
            @mouseover="setMessageInformation('Seleccione Si o no dependiendo de estar o no asegurada la carga')"
            @mouseleave="setMessageInformation()"
          >
            <div class="title-radio">
              <label
                class="labeltext"
                style="font-weight:600"
              >Está asegurado? <br>
                <sub>En caso de ser asegurado se le cobrará un 0.02%, de lo contrario se le cobrara un 2%</sub></label>
            </div>

            <div class="uk-margin uk-flex uk-column-1-2">
              <div>
                <label style="cursor: pointer">
                  <input
                    v-model="insuranceAndExtras.isInsured"
                    class="uk-radio"
                    type="radio"
                    name="radio1"
                    :value="insuranceExtrasEnum.insurance"
                  > Si</label>
              </div>
              <div>
                <label style="cursor: pointer">
                  <input
                    v-model="insuranceAndExtras.isInsured"
                    class="uk-radio"
                    type="radio"
                    name="radio1"
                    :value="insuranceExtrasEnum.notInsurance"
                  > No</label>
              </div>
            </div>
          </div>
          <div class="items uk-margin">
            <label
              class="labeltext"
              style="font-weight:600"
            >
              Contratación de Seguridad Privada (Para carga de alto valor)
            </label>

            <div
              class="uk-margin"
              @mouseover="setMessageInformation('Seleccione la cantidad de seguridad para la carga')"
              @mouseleave="setMessageInformation()"
            >
              <div>
                <input
                  id="quantity"
                  v-model="insuranceAndExtras.NumberPrivateSecurityUnits"
                  name="quantity"
                  min="0"
                  max="9999"
                  style="width: 12%;"
                  class="uk-input input-changes"
                  type="number"
                  placeholder="0"
                  @keydown="$helperPlugin.onlyNumber($event)"
                >  No. Unidades de seguridad privada
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { insuranceExtrasEnum, transportModeTypeEnum, directionTypeEnum } from '../../../types'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      insuranceExtrasEnum,
      transportModeTypeEnum,
      directionTypeEnum,
      lastValue: 0,

      insuranceAndExtras: {
        seaFreightImportInsurance: null,
        isInsured: null,
        NumberPrivateSecurityUnits: null
      },
      informationMsg: {
        image: null,
        message: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'insuranceAndExtrasStore',
      'transportMode',
      'journeyDirection'
    ])
  },
  watch: {
    insuranceAndExtras: {
      handler: function (newVal) {
        if (this.insuranceAndExtras.NumberPrivateSecurityUnits > 9999) {
          this.insuranceAndExtras.NumberPrivateSecurityUnits = this.lastValue
        }
        this.lastValue = this.insuranceAndExtras.NumberPrivateSecurityUnits
        this.$store.commit('setInsuranceAndExtras', newVal)
      },
      deep: true
    }
  },
  mounted () {
    this.insuranceAndExtras = { ...this.insuranceAndExtrasStore }
  },
  methods: {
    setMessageInformation (message, image) {
      this.informationMsg.image = image
      this.informationMsg.message = message

      this.$store.commit('setMessageInformation', this.informationMsg)
    }
  }
}
</script>

<style scoped>
*{
  font-size: 12px;
}
.sub-container{
min-height: 418px;;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
.container-section{
  padding: 10px 40px;
}
section{
  padding: 10px;
  width: 100%;
}

.title{
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}
.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}

.items{
  margin-bottom: 30px ;
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
  }
    .container-section{
    padding: 10px 20px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
 .opt{
    font-size: 10px;
  }

}
</style>
